<template>
    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />

        <div class="o-form__item">
            <div class="o-filelabel__wrap" data-filelabel="wrap">
                <div class="o-filelabel o-input__icon__wrap"
                    :class="{ 'has-file': selectedFile }"
                >
                    <input
                        v-show="!selectedFile"
                        ref="fileInput"
                        @change="setFileValue"
                        class="o-input-file o-filelabel__input"
                        :class="{ 'readonly': field.inputReadonly === true }"
                        v-on="readOnlyHandlers"
                        type="file"
                        :id="'input-'+field.id"
                        :name="field.inputName"
                        :placeholder="field.inputPlaceholder"
                        :required="(field.inputRequired === true) ? 'required' : false"
                        :accept="field.inputFileAllowedTypes"
                        :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                    >
                    <span class="o-filelabel__text" data-filelabel="text">
                        {{ placeholder }}
                        <button type="button" class="o-input__close" style="float:right" @click.stop="selectedFile=null; $refs.fileInput.value = null" v-if="selectedFile">
                            <span></span>
                            <span></span>
                        </button>
                        <svgIco icon="attachment" class="o-input__icon" />
                    </span>
                    <div class="o-form__validation">
                        <span class="o-form__validation__required">
                            {{ _t('Ce champ est obligatoire.') }}
                        </span>
                        <span class="o-form__validation__error">
                            {{ _t('Ce champ est invalide.') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <span class="o-form__instruction" v-if="field.inputInstructions && String(field.inputInstructions).trim() != ''">
            <small v-html="field.inputInstructions"></small>
        </span>
    </div>
</template>
<script>
    export default {
        name: 'Input-file',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
        	return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                },
                selectedFile: null,
                placeholder: this._t('Cliquez ici pour sélectionner un fichier')
        	}
        },
        computed: {
            placeholder() {
                return this.selectedFile || this._t('Cliquez ici pour sélectionner un fichier');
            }
        },
        methods: {
            setFileValue(e) {
                if (e.target.files.length > 0) {
                    this.selectedFile = e.target.files[0].name;
                } else {
                    this.selectedFile = null;
                }
            },

            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            }
        },
    }
</script>